import React from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from 'styles/GlobalStyles';
import theme from 'styles/theme';
import Router from 'router';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import 'styles/css/apple_sd.css';
import GoogleTagManager from 'components/GoogleTagManager';

function App() {
  const runMode = `${process.env.REACT_APP_RUN_MODE}`;
  return (
    <>
      <ThemeProvider theme={theme}>
        <HelmetProvider>
          <Helmet>
            <title>브리피</title>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content="브리피"/>
            <meta property="og:description" content="Bridge to Photo/Videography"/>
            <meta property="og:url" content="https://www.briphy.com"/> 
            <meta property="og:site_name" content="Bridge to Photo/Videography"/>
            <meta property="og:locale" content="ko_KR"/>
          </Helmet>
        </HelmetProvider>
        <GlobalStyles />
        <Router />
      </ThemeProvider>
      {runMode === 'prod' ? (
        <GoogleTagManager gtmId={`${process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID}`} />
      ) : ''}
    </>
  );
}

export default App;